import { Link } from "react-router-dom";

export const TermsCheckbox = ({ checked, onChange, error, testid = "terms-checkbox" }) => (
  <div>
    <label className="flex items-start gap-2 text-xs text-[var(--brand-text-muted)] cursor-pointer">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} aria-invalid={!!error}
        className="mt-0.5 h-4 w-4 accent-[var(--brand-accent)]" data-testid={testid} />
      <span>
        Leí y acepto los{" "}
        <Link to="/terminos" target="_blank" rel="noreferrer" className="font-bold text-[var(--brand-accent)] underline" data-testid={`${testid}-link`}>
          Términos y Condiciones de uso
        </Link>
      </span>
    </label>
    {error && <span role="alert" className="block text-xs text-red-600 mt-1 ml-6" data-testid={`${testid}-error`}>{error}</span>}
  </div>
);
